export const isPharmacyLocation = (locationId, locations = []) => {
  const loc = locations?.find((l) => l?.id === locationId);
  return (loc?.category ?? "").toLowerCase() === "pharmacy";
};

export const getPharmacyStockBatches = (
  stkId,
  clinicStocks = [],
  clinicId,
  locations = [],
) => {
  const reqStock = clinicStocks?.find((stc) => stc?.stockId === stkId);
  return (
    reqStock?.stockBatch
      ?.filter((btch) => {
        const clinicMat = btch?.createdBy === clinicId;
        const isQty = Number(btch?.quantity ?? 0) > 0;
        const isPharLoc = isPharmacyLocation(btch?.locationId, locations);
        return btch?.approved && clinicMat && isQty && isPharLoc;
      })
      ?.sort((a, b) => Number(a?.quantity ?? 0) - Number(b?.quantity ?? 0)) ??
    []
  );
};

export const getPharmacyBatchTotalQty = (
  stkId,
  clinicStocks = [],
  clinicId,
  locations = [],
) => {
  return getPharmacyStockBatches(
    stkId,
    clinicStocks,
    clinicId,
    locations,
  ).reduce((acc, bat) => acc + Number(bat?.quantity ?? 0), 0);
};
